/**
 * REVIEW COMPANIES REDUX REDUCERS
 *
 * @version 0.1
 */

import {

    REVIEW_INITIAL_PHASE,
    REVIEW_CATEGORIES_LOADED,
    REVIEW_SELECT_ITEM,
    REVIEW_DESELECT_ITEM,
    REVIEW_RESET_SELECTED_ITEMS,
    REVIEW_TABLE_URL_CHANGE,
    SET_PREVIEW_ITEMS,
    SET_PREVIEW_ALL,
    UPDATE_SELECTED_ITEMS,
    SET_SELECTED_ITEMS,
    REMOVE_SELECTED_ITEMS,
    REVIEW_TOTAL_COUNT_CHANGE,
    REVIEW_FILTER_COUNT_CHANGE,
    REVIEW_COMPANIES_SET_MODALS_STATE,
    REVIEW_COMPANIES_SAVE_BUTTON,
    REVIEW_COMPANIES_ACTIVATE_BUTTON

} from './ReviewCompanies.actions';

import {
    USER_INFO_SUCCESS
} from './../Main/Main.reducers';

import utils from './../../utils/utilities';

function reviewCompanies(state = null, action) {

    switch (action.type) {
        case USER_INFO_SUCCESS :
            if (action.payload.preferences) {
                if (action.payload.preferences.previewCompany) {
                    if (action.payload.preferences.previewCompany.riskAngle === "all") {
                        action.payload.preferences.previewCompany.riskAngle = "ANY_PESTLE"
                    }
                    if (action.payload.preferences.previewCompany.riskLevel === "all") {
                        action.payload.preferences.previewCompany.riskLevel = "ANY_LEVEL"
                    }
                }
                if (action.payload.preferences.reviewCompanies) {
                    let urlData = Object.assign({}, state.urlParams, action.payload.preferences.reviewCompanies);
                    return Object.assign(
                        {}, state, {
                            urlParams: urlData
                        }
                    );
                }
            }
            return state;

        case REVIEW_INITIAL_PHASE:
            return Object.assign(
                {}, state, {
                    stage:                  'initial',
                    warningDialog:          '',
                    categoryStore:          null,
                    selectedItems:          [],
                    previewItems:           [],
                    isPreviewAll:           false,
                    totalCount:             null,
                    filterCount:            null,
                    addNewCategoryMessage:  '',
                    saveButtonDisabled:     true,
                    activateButtonDisabled: true,
                    urlParams:              Object.assign({}, state.urlParams, {
                        categoryIdFilter: null,
                        searchFilter: null
                    })
                }
            );

        case REVIEW_CATEGORIES_LOADED:
            return Object.assign(
                {}, state, {
                    stage:         'loadedCategories',
                    categoryStore: action.payload
                }
            );

        case REVIEW_SELECT_ITEM:
            return Object.assign(
                {}, state, {
                    selectedItems: [...state.selectedItems, action.payload]
                }
            );

        case REVIEW_DESELECT_ITEM:
        {

            let deselectedItem = action.payload;

            if (deselectedItem !== -1) {

                return Object.assign(
                    {}, state, {
                        selectedItems: [
                            ...state.selectedItems.slice(0, deselectedItem),
                            ...state.selectedItems.slice(deselectedItem + 1)
                        ]
                    }
                );

            }

            return state;

        }

        case REVIEW_RESET_SELECTED_ITEMS:
            return Object.assign(
                {}, state, {
                    selectedItems: []
                }
            );

        case REVIEW_TABLE_URL_CHANGE:
        {
            return Object.assign(
                {}, state, {
                    urlParams: Object.assign({}, state.urlParams, action.payload)
                }
            );
        }

        case SET_PREVIEW_ITEMS:
            return Object.assign(
                {}, state, {
                    previewItems:     action.payload.previewItems.slice(0)
                }
            );

        case SET_PREVIEW_ALL:
            return Object.assign(
                {}, state, {
                    isPreviewAll: action.payload.isPreviewAll,
                    urlParams: Object.assign({}, state.urlParams, {
                        categoryIdFilter: null,
                        searchFilter: null
                    })
                }
            );

        case UPDATE_SELECTED_ITEMS: {
            let newArray = utils.mergeArraysByField('id', state.selectedItems, action.payload);
            return Object.assign(
                {}, state, {
                    selectedItems:     newArray
                }
            );
        }

        case SET_SELECTED_ITEMS: {
            return Object.assign(
                {}, state, {
                    selectedItems:     action.payload
                }
            );
        }

        case REMOVE_SELECTED_ITEMS: {
            let newArray = utils.subsetArrayByField('id', state.selectedItems, action.payload);
            return Object.assign(
                {}, state, {
                    selectedItems:     newArray
                }
            );
        }

        case REVIEW_TOTAL_COUNT_CHANGE:
        {
            return Object.assign(
                {}, state, {
                    totalCount: action.payload
                }
            );
        }

        case REVIEW_FILTER_COUNT_CHANGE:
        {
            return Object.assign(
                {}, state, {
                    filterCount: action.payload
                }
            );
        }

        case REVIEW_COMPANIES_SET_MODALS_STATE:
            return Object.assign(
                {}, state, {
                    warningDialog: action.payload
                }
            );

        case REVIEW_COMPANIES_SAVE_BUTTON:
            return Object.assign(
                {}, state, {
                    saveButtonDisabled: action.payload
                }
            );

        case REVIEW_COMPANIES_ACTIVATE_BUTTON:
            return Object.assign(
                {}, state, {
                    activateButtonDisabled: action.payload
                }
            );

        default:
            return state;

    }

}

export default reviewCompanies;


// WEBPACK FOOTER //
// ./src/scripts/pages/ReviewCompanies/ReviewCompanies.reducers.js